import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
Vue.use(VueResource);
Vue.use(VueCookie);

import header from '../../components/Header'
import video from '../../components/Video'
import mainbody from '../../components/IndexBody'
import utils from '../../components/Utils.vue'

var locale = utils.getLocale();
if (locale == null) {
  locale = "?";
} else {
  locale = '?locale='+locale;
}
locale = locale + '&pagename=index';
var name = 'index';
var props = {};

Vue.http.get(utils.getServerPath()+'/misc/data.is'+locale).then(response => {
  var data = JSON.parse(response.bodyText);
  if (!props.info) {
    props.info = {};
  }
  Object.keys(data).forEach(function(key) {
    props.info[key] = data[key];
  });

  new Vue({ // eslint-disable-line no-new
    el: '#header',
    render: function(h) {
      if (props.info.common_res != null) {
        return h(header, {props:{name:props.name, title:'Sampson B2B Distribution Service', header_text:props.info.common_res.header_text}});
      } else {
        return h(header, {props:{name:props.name, title:'Sampson B2B Distribution Service'}});
      }
    }
  })

  new Vue({ // eslint-disable-line no-new
    el: '#bg',
    render: function(h) {
      return h(video, {props:{}});
    }
  })

  new Vue({ // eslint-disable-line no-new
    el: '#mainbody',
    render: function(h) {
      return h(mainbody, {props:{name:name, title:'Home', info:props.info}});
    }
  })
});



// WEBPACK FOOTER //
// ./src/pages/index/index.js